import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from './../models/auth.service';
import { UserRoles } from '../config';

@Injectable()
export class DriverAdminAuthGuard implements CanActivate {
  constructor(private authService: AuthService
    , private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isAuthorized(UserRoles.DRIVER)) { return true; }

    // Store the attempted URL for redirecting 
    //this.authService.redirectUrl = state.url;

    // Navigate to the login page
    this.router.navigate(['/Unauthorized']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/guard/auth-guard-driveradmin.service.ts